import { cn } from '@/utils/cn'

export type ApprovalTab = 'financial' | 'financials' | 'details'

interface ApprovalDetailTabsProps {
  activeTab: ApprovalTab
  onTabChange: (tab: ApprovalTab) => void
}

export function ApprovalDetailTabs({
  activeTab,
  onTabChange,
}: ApprovalDetailTabsProps) {
  const tabs: { id: ApprovalTab; label: string }[] = [
    { id: 'financial', label: 'Financial Summary' },
    { id: 'financials', label: 'MFP vs AP' },
    { id: 'details', label: 'Plan Details' },
  ]

  return (
    <div className="inline-flex bg-[#fef2f3] border border-[#fee2e4] rounded-md p-1">
      {tabs.map(tab => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={cn(
            'px-4 py-1.5 text-sm font-medium rounded-sm transition-colors cursor-pointer',
            activeTab === tab.id
              ? 'bg-[#cf1f2e] text-white'
              : 'text-[#9b1924] hover:text-[#cf1f2e]'
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
